export default "__VITE_ASSET__CwP$Rgme__"